import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/src/styles/main.sass'

import store from '@/store'

Vue.use(Vuetify)

const theme = store.getters.getTheme

const vuetify = new Vuetify({
  customVariables: ['variables.scss'],
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1280
    },
    scrollBarWidth: 24
  },
  theme,
  icons: {
    iconfont: 'mdi'
  }
})

export default vuetify
